module.exports = __webpack_public_path__ + "images/mitsubishi_smallc907e3c98941a9fa19ce20e1fbbd56a2.png";